import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Onboarding from "@/pages/Onboarding";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MatchDetail from "@/pages/MatchDetail";
import KantoorProfiel from "@/pages/KantoorProfiel";
import InfoPage from "@/pages/InfoPage";
import OverOns from "@/pages/OverOns";
import KantoorPubliekProfiel from "@/pages/KantoorPubliekProfiel";
import MijnMatches from "@/pages/MijnMatches";
import Register from "@/pages/Register";
import Diensten from "@/pages/Diensten";
import ZoWerktHet from "@/pages/ZoWerktHet";
import VoorKantoren from "@/pages/VoorKantoren";
import Sem from "@/pages/Sem";
import { AuthProvider } from "@/contexts/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { SemFloating } from "@/components/SemFloating";

function AppRouter() {
  const location = useLocation();
  // Detect session_id in URL fragment synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/betaling-gelukt" element={<PaymentSuccess />} />
      <Route path="/login" element={<Login />} />
      <Route path="/aanmelden" element={<Register />} />
      <Route path="/mijn-matches" element={<MijnMatches />} />
      <Route path="/dashboard" element={<Dashboard section="overview" />} />
      <Route path="/dashboard/matches" element={<Dashboard section="matches" />} />
      <Route path="/dashboard/matches/:id" element={<MatchDetail />} />
      <Route path="/dashboard/gesprekken" element={<Dashboard section="gesprekken" />} />
      <Route path="/dashboard/klanten" element={<Dashboard section="klanten" />} />
      <Route path="/dashboard/agenda" element={<Dashboard section="agenda" />} />
      <Route path="/dashboard/berichten" element={<Dashboard section="berichten" />} />
      <Route path="/dashboard/facturatie" element={<Dashboard section="facturatie" />} />
      <Route path="/dashboard/profiel" element={<KantoorProfiel />} />
      <Route path="/dashboard/instellingen" element={<Dashboard section="instellingen" />} />
      <Route path="/zo-werkt-het" element={<ZoWerktHet />} />
      <Route path="/voor-klanten" element={<InfoPage variant="klanten" />} />
      <Route path="/voor-kantoren" element={<VoorKantoren />} />
      <Route path="/voor-dienstverleners" element={<VoorKantoren />} />
      <Route path="/over-ons" element={<OverOns />} />
      <Route path="/kantoren/:id" element={<KantoorPubliekProfiel />} />
      <Route path="/diensten" element={<Diensten />} />
      <Route path="/diensten/:categoryId" element={<Diensten />} />
      <Route path="/sem" element={<Sem />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <SemFloating />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
